import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useTheme } from "../../context/ThemeContext";

const offers = [
  "Customized training plan",
  "Fat loss + muscle building strategy",
  "Nutrition guidance built for your lifestyle",
  "Weekly accountability check-ins",
  "Technique correction and coaching support",
  "Performance, aesthetics, and injury-aware programming",
];

export default function OfferStack() {
  const { theme } = useTheme();
  return (
    <section
      className="py-8 relative md:py-8 mb-24 bg-[var(--dvx-bg)] transition-colors duration-300 bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: "url('/images/offerstack_bg.png')" }}
    >
      {/* Overlay */}
      <div
        className={`absolute inset-0 transition-all duration-300 ${
          theme === "dark" ? "bg-black/60" : "bg-white/20"
        }`}
      ></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left — heading */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-[var(--dvx-primary)] font-oswald text-sm uppercase tracking-widest">
              Offer Stack
            </span>
            <h2 className="mt-4 font-oswald text-4xl md:text-5xl font-bold text-[var(--dvx-text)] uppercase tracking-tight">
              What You Get With DVX Coaching
            </h2>
            <p className="mt-6 text-[var(--dvx-text-muted)] font-manrope text-lg leading-relaxed">
              Everything is built to remove guesswork and maximize results.
            </p>
          </motion.div>

          {/* Right — 2-col grid of feature cards */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="grid grid-cols-2 gap-4"
          >
            {offers.map((offer, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08 }}
                className="bg-[var(--dvx-surface)] border border-[var(--dvx-border)] p-5 flex flex-col gap-4 hover:border-[var(--dvx-primary)]/50 transition-colors duration-300"
              >
                <div className="w-8 h-8 bg-[var(--dvx-primary)]/10 border border-[var(--dvx-primary)]/30 flex items-center justify-center flex-shrink-0">
                  <Check size={14} className="text-[var(--dvx-primary)]" />
                </div>
                <p className="font-manrope text-sm text-[var(--dvx-text)] leading-snug">
                  {offer}
                </p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
